export const codeCircle = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.99945 14.75C7.80945 14.75 7.61945 14.68 7.46945 14.53L5.46945 12.53C5.17945 12.24 5.17945 11.7599 5.46945 11.4699L7.46945 9.46994C7.75945 9.17994 8.23945 9.17994 8.52945 9.46994C8.81945 9.75994 8.81945 10.24 8.52945 10.53L7.05945 12L8.52945 13.4699C8.81945 13.7599 8.81945 14.24 8.52945 14.53C8.37945 14.68 8.18945 14.75 7.99945 14.75Z'
      fill='#ACACAC'
    />
    <path
      d='M15.9995 14.75C15.8095 14.75 15.6195 14.68 15.4695 14.53C15.1795 14.24 15.1795 13.7599 15.4695 13.4699L16.9395 12L15.4695 10.53C15.1795 10.24 15.1795 9.75994 15.4695 9.46994C15.7595 9.17994 16.2395 9.17994 16.5295 9.46994L18.5295 11.4699C18.8195 11.7599 18.8195 12.24 18.5295 12.53L16.5295 14.53C16.3795 14.68 16.1895 14.75 15.9995 14.75Z'
      fill='#ACACAC'
    />
    <path
      d='M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z'
      fill='#ACACAC'
    />
    <path
      d='M11.0001 15.0801C10.9001 15.0801 10.8001 15.0601 10.7101 15.0201C10.3301 14.8601 10.1501 14.4201 10.3201 14.0301L12.3201 9.36004C12.4801 8.98004 12.9201 8.80002 13.3001 8.97002C13.6801 9.13002 13.8601 9.57008 13.6901 9.96008L11.6901 14.6301C11.5701 14.9101 11.2901 15.0801 11.0001 15.0801Z'
      fill='#ACACAC'
    />
  </svg>
);

export const stars = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15 1.5L15.5772 4.0624C16.0668 6.23587 17.7641 7.93319 19.9376 8.42279L22.5 9L19.9376 9.57721C17.7641 10.0668 16.0668 11.7641 15.5772 13.9376L15 16.5L14.4228 13.9376C13.9332 11.7641 12.2359 10.0668 10.0624 9.57721L7.5 9L10.0624 8.42279C12.2358 7.93319 13.9332 6.23587 14.4228 4.06241L15 1.5Z'
      stroke='#ACACAC'
      stroke-width='1.5'
      stroke-linejoin='round'
    />
    <path
      d='M7 12.5L7.42329 14.2083C7.78233 15.6572 9.02703 16.7888 10.6209 17.1152L12.5 17.5L10.6209 17.8848C9.02703 18.2112 7.78233 19.3427 7.42329 20.7917L7 22.5L6.57671 20.7917C6.21767 19.3427 4.97298 18.2112 3.3791 17.8848L1.5 17.5L3.3791 17.1152C4.97298 16.7888 6.21767 15.6573 6.57671 14.2083L7 12.5Z'
      stroke='#ACACAC'
      stroke-width='1.5'
      stroke-linejoin='round'
    />
  </svg>
);

export const cloud = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.46124 19.3401H5.5412C2.6012 19.1301 1.28125 16.8701 1.28125 14.8601C1.28125 12.8501 2.60121 10.5801 5.49121 10.3801C5.90121 10.3401 6.2612 10.6601 6.2912 11.0801C6.3212 11.4901 6.01125 11.8501 5.59125 11.8801C3.65125 12.0201 2.78125 13.4801 2.78125 14.8701C2.78125 16.2601 3.65125 17.7201 5.59125 17.8601H7.46124C7.87124 17.8601 8.21124 18.2001 8.21124 18.6101C8.21124 19.0201 7.87124 19.3401 7.46124 19.3401Z'
      fill='#ACACAC'
    />
    <path
      d='M16.6709 19.34C16.6509 19.34 16.6409 19.34 16.6209 19.34C16.2109 19.34 15.8309 19 15.8309 18.59C15.8309 18.16 16.1509 17.84 16.5709 17.84C17.8009 17.84 18.9009 17.41 19.7609 16.64C21.3209 15.28 21.4209 13.32 21.0009 11.94C20.5809 10.57 19.4109 9 17.3709 8.75C17.0409 8.71 16.7809 8.46001 16.7209 8.13001C16.3209 5.73001 15.0309 4.07 13.0709 3.47C11.0509 2.84 8.69086 3.46 7.22086 5C5.79086 6.49 5.46087 8.58001 6.29087 10.88C6.43087 11.27 6.23092 11.7 5.84092 11.84C5.45092 11.98 5.0209 11.78 4.8809 11.39C3.8709 8.57 4.33091 5.87 6.14091 3.97C7.99091 2.03 10.9609 1.26 13.5109 2.04C15.8509 2.76 17.5009 4.69 18.1009 7.37C20.1409 7.83 21.7809 9.38001 22.4309 11.52C23.1409 13.85 22.5009 16.25 20.7509 17.77C19.6409 18.77 18.1909 19.34 16.6709 19.34Z'
      fill='#ACACAC'
    />
    <path
      d='M12 22.28C9.99 22.28 8.11002 21.21 7.08002 19.48C6.97002 19.31 6.86002 19.11 6.77002 18.89C6.43002 18.18 6.25 17.37 6.25 16.53C6.25 13.36 8.83 10.78 12 10.78C15.17 10.78 17.75 13.36 17.75 16.53C17.75 17.38 17.57 18.18 17.21 18.92C17.13 19.11 17.02 19.31 16.9 19.5C15.89 21.21 14.01 22.28 12 22.28ZM12 12.28C9.66 12.28 7.75 14.19 7.75 16.53C7.75 17.15 7.88 17.73 8.13 18.26C8.21 18.43 8.27999 18.57 8.35999 18.7C9.11999 19.99 10.51 20.78 11.99 20.78C13.47 20.78 14.86 19.99 15.61 18.72C15.7 18.57 15.78 18.43 15.84 18.29C16.11 17.74 16.24 17.16 16.24 16.54C16.25 14.19 14.34 12.28 12 12.28Z'
      fill='#ACACAC'
    />
    <path
      d='M11.4289 18.27C11.2389 18.27 11.049 18.2 10.899 18.05L9.90891 17.06C9.61891 16.77 9.61891 16.29 9.90891 16C10.1989 15.71 10.6789 15.71 10.9689 16L11.4489 16.48L13.0489 15C13.3589 14.72 13.8289 14.74 14.1089 15.04C14.3889 15.34 14.3689 15.82 14.0689 16.1L11.9389 18.07C11.7889 18.2 11.6089 18.27 11.4289 18.27Z'
      fill='#ACACAC'
    />
  </svg>
);

export const persona = (
  <svg
    width='56'
    height='56'
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.5'
      y='0.5'
      width='55'
      height='55'
      rx='27.5'
      fill='white'
      fill-opacity='0.05'
    />
    <rect x='0.5' y='0.5' width='55' height='55' rx='27.5' stroke='#392151' />
    <path
      d='M27.9999 42.3333C27.1065 42.3333 26.1999 42.1066 25.3999 41.64L17.4799 37.0667C15.8799 36.1333 14.8799 34.4133 14.8799 32.56V23.44C14.8799 21.5867 15.8799 19.8667 17.4799 18.9334L25.3999 14.36C26.9999 13.4267 28.9865 13.4267 30.5999 14.36L38.5199 18.9334C40.1199 19.8667 41.1199 21.5867 41.1199 23.44V32.56C41.1199 34.4133 40.1199 36.1333 38.5199 37.0667L30.5999 41.64C29.7999 42.1066 28.8932 42.3333 27.9999 42.3333ZM27.9999 15.6667C27.4532 15.6667 26.8932 15.8134 26.3999 16.0934L18.4799 20.6667C17.4932 21.24 16.8799 22.2934 16.8799 23.44V32.56C16.8799 33.6933 17.4932 34.76 18.4799 35.3333L26.3999 39.9067C27.3865 40.48 28.6132 40.48 29.5999 39.9067L37.5199 35.3333C38.5065 34.76 39.1199 33.7067 39.1199 32.56V23.44C39.1199 22.3067 38.5065 21.24 37.5199 20.6667L29.5999 16.0934C29.1065 15.8134 28.5465 15.6667 27.9999 15.6667Z'
      fill='#C49EFF'
    />
    <path
      d='M28.0002 27.6668C25.7336 27.6668 23.8936 25.8268 23.8936 23.5601C23.8936 21.2934 25.7336 19.4535 28.0002 19.4535C30.2669 19.4535 32.1069 21.2934 32.1069 23.5601C32.1069 25.8268 30.2669 27.6668 28.0002 27.6668ZM28.0002 21.4535C26.8402 21.4535 25.8936 22.4001 25.8936 23.5601C25.8936 24.7201 26.8402 25.6668 28.0002 25.6668C29.1602 25.6668 30.1069 24.7201 30.1069 23.5601C30.1069 22.4001 29.1602 21.4535 28.0002 21.4535Z'
      fill='#C49EFF'
    />
    <path
      d='M33.3337 35.2134C32.787 35.2134 32.3337 34.7601 32.3337 34.2134C32.3337 32.3734 30.387 30.8668 28.0003 30.8668C25.6137 30.8668 23.667 32.3734 23.667 34.2134C23.667 34.7601 23.2137 35.2134 22.667 35.2134C22.1203 35.2134 21.667 34.7601 21.667 34.2134C21.667 31.2668 24.507 28.8668 28.0003 28.8668C31.4937 28.8668 34.3337 31.2668 34.3337 34.2134C34.3337 34.7601 33.8803 35.2134 33.3337 35.2134Z'
      fill='#C49EFF'
    />
  </svg>
);

export const brain = (
  <svg
    width='56'
    height='56'
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.5'
      y='0.5'
      width='55'
      height='55'
      rx='27.5'
      fill='white'
      fill-opacity='0.05'
    />
    <rect x='0.5' y='0.5' width='55' height='55' rx='27.5' stroke='#392151' />
    <path
      d='M31.1997 39.6667H24.7997C18.9463 39.6667 16.333 37.0534 16.333 31.2V24.8C16.333 18.9467 18.9463 16.3334 24.7997 16.3334H31.1997C37.053 16.3334 39.6663 18.9467 39.6663 24.8V31.2C39.6663 37.0534 37.053 39.6667 31.1997 39.6667ZM24.7997 18.3334C20.0263 18.3334 18.333 20.0267 18.333 24.8V31.2C18.333 35.9734 20.0263 37.6667 24.7997 37.6667H31.1997C35.973 37.6667 37.6663 35.9734 37.6663 31.2V24.8C37.6663 20.0267 35.973 18.3334 31.1997 18.3334H24.7997Z'
      fill='#C49EFF'
    />
    <path
      d='M29.9997 35.6667H25.9997C22.133 35.6667 20.333 33.8667 20.333 30V26C20.333 22.1334 22.133 20.3334 25.9997 20.3334H29.9997C33.8663 20.3334 35.6663 22.1334 35.6663 26V30C35.6663 33.8667 33.8663 35.6667 29.9997 35.6667ZM25.9997 22.3334C23.2263 22.3334 22.333 23.2267 22.333 26V30C22.333 32.7734 23.2263 33.6667 25.9997 33.6667H29.9997C32.773 33.6667 33.6663 32.7734 33.6663 30V26C33.6663 23.2267 32.773 22.3334 29.9997 22.3334H25.9997Z'
      fill='#C49EFF'
    />
    <path
      d='M22.6797 18.3333C22.1197 18.3333 21.6797 17.88 21.6797 17.3333V14.6666C21.6797 14.12 22.133 13.6666 22.6797 13.6666C23.2264 13.6666 23.6797 14.12 23.6797 14.6666V17.3333C23.6797 17.88 23.2264 18.3333 22.6797 18.3333Z'
      fill='#C49EFF'
    />
    <path
      d='M28 18.3333C27.4533 18.3333 27 17.88 27 17.3333V14.6666C27 14.12 27.4533 13.6666 28 13.6666C28.5467 13.6666 29 14.12 29 14.6666V17.3333C29 17.88 28.5467 18.3333 28 18.3333Z'
      fill='#C49EFF'
    />
    <path
      d='M33.333 18.3333C32.7863 18.3333 32.333 17.88 32.333 17.3333V14.6666C32.333 14.12 32.7863 13.6666 33.333 13.6666C33.8797 13.6666 34.333 14.12 34.333 14.6666V17.3333C34.333 17.88 33.8797 18.3333 33.333 18.3333Z'
      fill='#C49EFF'
    />
    <path
      d='M41.3337 23.6666H38.667C38.1203 23.6666 37.667 23.2133 37.667 22.6666C37.667 22.12 38.1203 21.6666 38.667 21.6666H41.3337C41.8803 21.6666 42.3337 22.12 42.3337 22.6666C42.3337 23.2133 41.8937 23.6666 41.3337 23.6666Z'
      fill='#C49EFF'
    />
    <path
      d='M41.3337 29H38.667C38.1203 29 37.667 28.5467 37.667 28C37.667 27.4533 38.1203 27 38.667 27H41.3337C41.8803 27 42.3337 27.4533 42.3337 28C42.3337 28.5467 41.8937 29 41.3337 29Z'
      fill='#C49EFF'
    />
    <path
      d='M41.3337 34.3334H38.667C38.1203 34.3334 37.667 33.88 37.667 33.3334C37.667 32.7867 38.1203 32.3334 38.667 32.3334H41.3337C41.8803 32.3334 42.3337 32.7867 42.3337 33.3334C42.3337 33.88 41.8937 34.3334 41.3337 34.3334Z'
      fill='#C49EFF'
    />
    <path
      d='M33.333 42.3333C32.7863 42.3333 32.333 41.88 32.333 41.3333V38.6666C32.333 38.12 32.7863 37.6666 33.333 37.6666C33.8797 37.6666 34.333 38.12 34.333 38.6666V41.3333C34.333 41.88 33.8797 42.3333 33.333 42.3333Z'
      fill='#C49EFF'
    />
    <path
      d='M28.0127 42.3333C27.466 42.3333 27.0127 41.88 27.0127 41.3333V38.6666C27.0127 38.12 27.466 37.6666 28.0127 37.6666C28.5594 37.6666 29.0127 38.12 29.0127 38.6666V41.3333C29.0127 41.88 28.5594 42.3333 28.0127 42.3333Z'
      fill='#C49EFF'
    />
    <path
      d='M22.6797 42.3333C22.133 42.3333 21.6797 41.88 21.6797 41.3333V38.6666C21.6797 38.12 22.133 37.6666 22.6797 37.6666C23.2264 37.6666 23.6797 38.12 23.6797 38.6666V41.3333C23.6797 41.88 23.2264 42.3333 22.6797 42.3333Z'
      fill='#C49EFF'
    />
    <path
      d='M17.3337 23.6666H14.667C14.1203 23.6666 13.667 23.2266 13.667 22.6666C13.667 22.1066 14.1203 21.6666 14.667 21.6666H17.3337C17.8803 21.6666 18.3337 22.12 18.3337 22.6666C18.3337 23.2133 17.8937 23.6666 17.3337 23.6666Z'
      fill='#C49EFF'
    />
    <path
      d='M17.3337 29H14.667C14.1203 29 13.667 28.5467 13.667 28C13.667 27.4533 14.1203 27 14.667 27H17.3337C17.8803 27 18.3337 27.4533 18.3337 28C18.3337 28.5467 17.8937 29 17.3337 29Z'
      fill='#C49EFF'
    />
    <path
      d='M17.3337 34.3334H14.667C14.1203 34.3334 13.667 33.88 13.667 33.3334C13.667 32.7867 14.1203 32.3334 14.667 32.3334H17.3337C17.8803 32.3334 18.3337 32.7867 18.3337 33.3334C18.3337 33.88 17.8937 34.3334 17.3337 34.3334Z'
      fill='#C49EFF'
    />
  </svg>
);

export const lightning = (
  <svg
    width='56'
    height='56'
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.5'
      y='0.5'
      width='55'
      height='55'
      rx='27.5'
      fill='white'
      fill-opacity='0.05'
    />
    <rect x='0.5' y='0.5' width='55' height='55' rx='27.5' stroke='#392151' />
    <path
      d='M25.3195 42.3333C25.0528 42.3333 24.8395 42.28 24.6795 42.2133C24.1461 42.0133 23.2395 41.36 23.2395 39.2933V30.6933H20.1195C18.3328 30.6933 17.6928 29.8533 17.4661 29.36C17.2395 28.8533 17.0395 27.8267 18.2128 26.48L28.3061 15.0133C29.6661 13.4667 30.7728 13.5733 31.3061 13.7733C31.8395 13.9733 32.7461 14.6267 32.7461 16.6933V25.2933H35.8661C37.6528 25.2933 38.2928 26.1333 38.5195 26.6267C38.7461 27.1333 38.9461 28.16 37.7728 29.5067L27.6795 40.9733C26.7328 42.0533 25.9061 42.3333 25.3195 42.3333ZM30.5728 15.6533C30.5328 15.7067 30.2528 15.84 29.8128 16.3467L19.7195 27.8133C19.3461 28.24 19.2928 28.5067 19.2928 28.56C19.3195 28.5733 19.5595 28.7067 20.1195 28.7067H24.2395C24.7861 28.7067 25.2395 29.16 25.2395 29.7067V39.3067C25.2395 39.9733 25.3595 40.2667 25.4128 40.3467C25.4528 40.2933 25.7328 40.16 26.1728 39.6533L36.2661 28.1867C36.6395 27.76 36.6928 27.4933 36.6928 27.44C36.6661 27.4267 36.4261 27.2933 35.8661 27.2933H31.7461C31.1995 27.2933 30.7461 26.84 30.7461 26.2933V16.6933C30.7595 16.0267 30.6261 15.7467 30.5728 15.6533Z'
      fill='#C49EFF'
    />
  </svg>
);

export const web = (
  <svg
    width='56'
    height='56'
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.5'
      y='0.5'
      width='55'
      height='55'
      rx='27.5'
      fill='white'
      fill-opacity='0.05'
    />
    <rect x='0.5' y='0.5' width='55' height='55' rx='27.5' stroke='#214C51' />
    <path
      d='M28.0003 42.3333C20.0937 42.3333 13.667 35.9066 13.667 28C13.667 20.0933 20.0937 13.6666 28.0003 13.6666C35.907 13.6666 42.3337 20.0933 42.3337 28C42.3337 35.9066 35.907 42.3333 28.0003 42.3333ZM28.0003 15.6666C21.2003 15.6666 15.667 21.2 15.667 28C15.667 34.8 21.2003 40.3333 28.0003 40.3333C34.8003 40.3333 40.3337 34.8 40.3337 28C40.3337 21.2 34.8003 15.6666 28.0003 15.6666Z'
      fill='#6ADCF1'
    />
    <path
      d='M24.0003 41H22.667C22.1203 41 21.667 40.5467 21.667 40C21.667 39.4533 22.0936 39.0133 22.6403 39C20.547 31.8533 20.547 24.1467 22.6403 17C22.0936 16.9867 21.667 16.5467 21.667 16C21.667 15.4533 22.1203 15 22.667 15H24.0003C24.3203 15 24.627 15.16 24.8136 15.4133C25.0003 15.68 25.0536 16.0133 24.947 16.32C22.4403 23.8533 22.4403 32.1467 24.947 39.6933C25.0536 40 25.0003 40.3333 24.8136 40.6C24.627 40.84 24.3203 41 24.0003 41Z'
      fill='#6ADCF1'
    />
    <path
      d='M32.0002 41.0001C31.8935 41.0001 31.7869 40.9867 31.6802 40.9467C31.1602 40.7734 30.8669 40.2001 31.0535 39.6801C33.5602 32.1467 33.5602 23.8534 31.0535 16.3067C30.8802 15.7867 31.1602 15.2134 31.6802 15.0401C32.2135 14.8667 32.7735 15.1467 32.9469 15.6667C35.6002 23.6134 35.6002 32.3601 32.9469 40.2934C32.8135 40.7334 32.4135 41.0001 32.0002 41.0001Z'
      fill='#6ADCF1'
    />
    <path
      d='M28 34.9334C24.28 34.9334 20.5733 34.4134 17 33.3601C16.9867 33.8934 16.5467 34.3334 16 34.3334C15.4533 34.3334 15 33.8801 15 33.3334V32.0001C15 31.6801 15.16 31.3734 15.4133 31.1867C15.68 31.0001 16.0133 30.9467 16.32 31.0534C23.8533 33.5601 32.16 33.5601 39.6933 31.0534C40 30.9467 40.3333 31.0001 40.6 31.1867C40.8667 31.3734 41.0133 31.6801 41.0133 32.0001V33.3334C41.0133 33.8801 40.56 34.3334 40.0133 34.3334C39.4667 34.3334 39.0267 33.9067 39.0133 33.3601C35.4267 34.4134 31.72 34.9334 28 34.9334Z'
      fill='#6ADCF1'
    />
    <path
      d='M40 25C39.8934 25 39.7867 24.9867 39.68 24.9467C32.1467 22.44 23.84 22.44 16.3067 24.9467C15.7734 25.12 15.2134 24.84 15.04 24.32C14.88 23.7867 15.16 23.2267 15.68 23.0534C23.6267 20.4 32.3734 20.4 40.3067 23.0534C40.8267 23.2267 41.12 23.8 40.9334 24.32C40.8134 24.7334 40.4134 25 40 25Z'
      fill='#6ADCF1'
    />
  </svg>
);

export const dot = (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='6' cy='6' r='2' fill='#ECEDEE' />
    <circle cx='6' cy='6' r='5.5' stroke='#ACACAC' />
  </svg>
);

export const chevron = (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7 10L12 15L17 10'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
